import React, { useState } from "react";
import { Segment, Button, Rating } from "semantic-ui-react";
import Swal from "sweetalert2";
import { apiViaje } from "../../api/viaje";
import "../../scss/index.scss";
import { Player } from "@lottiefiles/react-lottie-player";
import animacion from "../../imagenes/Viaje/Finalizado.json";
import animacionValorar from "../../imagenes/Viaje/Valorar2.json";

const apiviaje = new apiViaje();

export function ViajeFinalizado({ Id, Estado, Destino, Precio, Moneda }) {
  const [Respondio, setRespondio] = useState(0);
  const [VerValorar, setVerValorar] = useState(0);

  const [Rating_LocalPoint, setRating_LocalPoint] = useState(0);
  const [Rating_Conductor, setRating_Conductor] = useState(0);
  const [Rating_Vehiculo, setRating_Vehiculo] = useState(0);

  const LlegasteADestino = async () => {
    const respuesta = await apiviaje.llegasteADestino(Id, 1);

    if (respuesta.status === 200) {
      Swal.fire({
        title: "Gracias por confiar en Local Point",
        text: "Esperamos que tu viaje haya sido lo esperado",
        timer: 3000,
        showCancelButton: false,
        showConfirmButton: false,
      });

      setRespondio(1);
      setVerValorar(1);
    }
  };

  const NoLlegasteADestino = async () => {
    const respuesta = await apiviaje.llegasteADestino(Id, 0);

    if (respuesta.status === 200) {
      Swal.fire({
        title:
          "Nos comunicaremos contigo para conocer en detalle acerca de lo ocurrido",
        text: "",
        timer: 4000,
        showCancelButton: false,
        showConfirmButton: false,
      });

      setRespondio(1);
    }
  };

  const EnviarValoracion = async () => {
    const respuesta = await apiviaje.valorar(
      Id,
      Rating_LocalPoint,
      Rating_Conductor,
      Rating_Vehiculo
    );

    if (respuesta.status === 200) {
      Swal.fire({
        title: "Valoración enviada correctamente",
        text: "",
        timer: 3000,
        showCancelButton: false,
        showConfirmButton: false,
      });

      setVerValorar(0);
    }
  };

  const handleRating_localpoint = (e, { rating }) => {
    e.preventDefault();
    setRating_LocalPoint(rating);
  };

  const handleRating_conductor = (e, { rating }) => {
    e.preventDefault();
    setRating_Conductor(rating);
  };

  const handleRating_vehiculo = (e, { rating }) => {
    e.preventDefault();
    setRating_Vehiculo(rating);
  };

  return (
    <div>
      <Segment secondary className="segmentViajeFinalizado">
        {Respondio === 0 ? (
          <div>
            <Player
              src={animacion}
              className="player"
              loop
              autoplay
              style={{ height: 100 }}
            />
            <br></br>
            <div style={{ textAlign: "center" }}>
              Tu viaje a <b>{Destino}</b> ha finalizado.<br></br>
              <br></br>
            </div>
            <div style={{ textAlign: "center" }}>Llegaste a destino?:</div>
          </div>
        ) : (
          <div></div>
        )}
        <div style={{ textAlign: "Center" }}>
          {Respondio === 0 ? (
            <div>
              <Button onClick={(e) => LlegasteADestino(e)}>Si</Button>
              <Button basic onClick={(e) => NoLlegasteADestino(e)}>
                No
              </Button>
            </div>
          ) : (
            <div></div>
          )}

          {VerValorar === 1 ? (
            <div>
              Ayúdanos a mejorar nuestro servicio y valora los siguientes items:
              <br></br>
              <br></br>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>Local Point</td>
                    <td>
                      <Rating
                        icon="star"
                        defaultRating={0}
                        maxRating={5}
                        size="huge"
                        onRate={handleRating_localpoint}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Conductor</td>
                    <td>
                      <Rating
                        icon="star"
                        defaultRating={0}
                        maxRating={5}
                        size="huge"
                        onRate={handleRating_conductor}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Vehículo</td>
                    <td>
                      <Rating
                        icon="star"
                        defaultRating={0}
                        maxRating={5}
                        size="huge"
                        onRate={handleRating_vehiculo}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <br></br>
              <button
                className="ui fluid button"
                onClick={(e) => EnviarValoracion(e)}
              >
                Enviar valoración
              </button>
              <Player
                src={animacionValorar}
                className="player"
                loop
                autoplay
                style={{ height: 70 }}
              />
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </Segment>
    </div>
  );
}
